<template>
  <div
    class="project-structure"
    >
    <div
      class="project-structure-sidebar-left">
      <div class="project-structure-sidebar-left-body">
        <slot name="sidebar-left"/>
      </div>
      <div class="project-structure-sidebar-left-footer">
        <slot name="sidebar-left-footer"/>
      </div>
    </div>
    <div class="project-structure-main">
      <slot name="main"/>
    </div>
    <div
      class="project-structure-sidebar-right"
      >
      <div class="project-structure-sidebar-left-body">
        <slot name="sidebar-right"/>
      </div>
      <div class="project-structure-sidebar-left-footer">
        <slot name="sidebar-right-footer"/>
      </div>
    </div>
    <slot/>
  </div>
</template>
<script>
  export default {
    props: [],
    data: () => ({
    }),
  }
</script>
<style>
  .project-structure {
    position: absolute;
    display: flex;
    /* height: calc(100% - 78px) !important; */
    padding: 2px;
  }
  .project-structure-sidebar-left {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 50%;
    height: 100%;
    padding: 6px;
    box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.4);
    z-index: 1;
    background-color: rgb(41,41,41);
    overflow-x: auto;
  }
  .project-structure-sidebar-left-body {
    position: relative;
    height: calc(100% - 45px);
    width: 100%;
    border-bottom: solid 1px rgb(30,30,30);
    overflow: auto;
    padding-bottom: 30px;
  }
  .project-structure-sidebar-left-footer {
    display: flex;
    height: 45px;
    align-items: center;
    justify-content: space-around;
  }
  .project-structure-sidebar-right {
    position: relative;
    right: 0px;
    display: flex;
    flex-direction: column;
    width: 50%;
    padding: 6px;
    box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.4);
    z-index: 1;
    background-color: rgb(41,41,41);
  }
  .project-structure-main {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    min-width: 4px;
    height: 100%;
    background-color: rgb(30,30,30);
  }
</style>
